// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MarkdownUnlinkExtended } from '../../../../../ui-v3/src/assets/icons/extended/markdown/markdown-unlink.svg?react';
import { createIcons } from '../../Icon';
const MarkdownUnlinkIcon = /* @__PURE__ */ createIcons('MarkdownUnlink', {
    extended: MarkdownUnlinkExtended
});
MarkdownUnlinkIcon.supportedTypes = [
    'extended'
];
MarkdownUnlinkIcon.category = 'markdown';
export default MarkdownUnlinkIcon;
